import React, { useEffect, useState } from "react";
import { supabase } from "../supabase/client";
import {
  FiCalendar,
  FiActivity,
  FiTrendingUp,
  FiTrendingDown,
} from "react-icons/fi";
import "./Dashboard.css";
import "./global.css";

const Dashboard = () => {
  const [todayCount, setTodayCount] = useState(0);
  const [activeCarwashes, setActiveCarwashes] = useState(0);
  const [prevDayCount, setPrevDayCount] = useState(0); // For trend comparison
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      setLoading(true);

      // Get today's check-ins
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const isoStart = today.toISOString();

      const { count: checkinsToday } = await supabase
        .from("check_ins")
        .select("*", { count: "exact", head: true })
        .gte("check_in_time", isoStart);

      // Get yesterday's check-ins for trend
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const isoYesterday = yesterday.toISOString();

      const { count: checkinsYesterday } = await supabase
        .from("check_ins")
        .select("*", { count: "exact", head: true })
        .gte("check_in_time", isoYesterday)
        .lt("check_in_time", isoStart);

      // Get active carwashes - FIXED: using active_status instead of active
      const { count: activeWashCount } = await supabase
        .from("carwashes")
        .select("*", { count: "exact", head: true })
        .eq("active_status", true); // Changed from "active" to "active_status"

      setTodayCount(checkinsToday || 0);
      setPrevDayCount(checkinsYesterday || 0);
      setActiveCarwashes(activeWashCount || 0);
      setLoading(false);
    };

    fetchStats();
  }, []);

  if (loading) return <div className="loading-spinner">Loading...</div>;

  // Calculate trend percentage
  const trendPercentage = prevDayCount
    ? Math.round(((todayCount - prevDayCount) / prevDayCount) * 100)
    : 0;

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard Overview</h1>

      <div className="stats-grid">
        {/* Today's Check-Ins Card */}
        <div className="card stat-card">
          <div className="stat-icon">
            <FiCalendar size={24} />
          </div>
          <div className="stat-content">
            <h3 className="stat-title">Check-Ins Today</h3>
            <p className="stat-value">{todayCount}</p>
            <div
              className={`stat-trend ${trendPercentage >= 0 ? "positive" : "negative"
                }`}
            >
              {trendPercentage >= 0 ? <FiTrendingUp /> : <FiTrendingDown />}
              <span>{Math.abs(trendPercentage)}%</span>
            </div>
          </div>
        </div>

        {/* Active Car Washes Card */}
        <div className="card stat-card">
          <div className="stat-icon">
            <FiActivity size={24} />
          </div>
          <div className="stat-content">
            <h3 className="stat-title">Active Car Washes</h3>
            <p className="stat-value">{activeCarwashes}</p>
            <div className="stat-trend neutral">
              <span>Real-time</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;